export enum SalesItemType {
    ClinicService = 1,
    PrescriptionProduct = 2,
    LicenseFee = 3,
    VetcoPrescription = 4,
    CouponDiscountMonetary = 5,
    CouponDiscountPercentage = 6,
    RebateProducts = 7,
    RebateServices = 8,
    FeeNonTaxable = 9,
    FeeTaxable = 10
}

export const DiscountItemTypes = [
    SalesItemType.CouponDiscountMonetary,
    SalesItemType.CouponDiscountPercentage,
    SalesItemType.RebateProducts,
    SalesItemType.RebateServices
];
